import Model from './Model'

export default class MailFormTemplates extends Model {
    resource() {
        return 'mailform-templates'
    }


    // update mailform template
    templateUpdate(data) {
        return this.request({
            url: `${this.resource()}/${data.id}`,
            method: 'put',
            data: {
                name: data.name,
            }
        });
    }

    // delete mailform template
    templateDelete(id) {
        return this.request({
            url: `${this.resource()}/${id}`,
            method: 'delete',
        });
    }
}
